<template>
  <div id="detail-facebook-logs-page">
    <b-card no-body class="h-100">
      <!-- header component -->
      <b-card-header>
        <div>
          <!-- title -->
          <b-card-title class="d-flex align-items-center">
            <i class="bi bi-info-circle"></i>
            <span style="margin-left: 5px">
              Detail Postingan pada Akun Facebook <strong>{{ filter_data.account }}</strong>
            </span>
          </b-card-title>
        </div>
        <!-- filter component -->
        <div
          class="d-flex flex-wrap gap-5px justify-content-end align-items-center"
        >
          <!-- back button -->
          <b-button variant="outline-info" @click="goBack()">
            <feather-icon icon="ArrowLeftCircleIcon" /> Kembali
          </b-button>
        </div>
      </b-card-header>
      <div class="mt-1">
        <!-- loader component -->
        <loader-component v-if="is_loading" />
        <!-- table component -->
        <table-component v-else 
          :data="table_data" 
          :is_pagination="false"
          :is_row_clicked="true"
          :viewDetail="viewDetail"
        />
        <paginationInfo
          :page="pagination.page"
          :items="pagination.items"
          :count="pagination.count"
          @update-value="paginationChanged"
        />
        <!-- content modal component -->
        <contentModal :data="modal_data" />
      </div>
    </b-card>
  </div>
</template>
<script>
import useJwt from "@/auth/jwt/useJwt";
import dataTable from "@/views/components/dataTable.vue";
import loader from "@/views/components/loader.vue";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import axios from "axios";
import paginationInfo from "@/views/components/paginationInfo.vue";
import contentModal from "@/views/components/facebook/contentModal.vue";

export default {
  name: "FacebookLogsDetail",
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardSubTitle,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    paginationInfo,
    "table-component": dataTable,
    "loader-component": loader,
    contentModal,
  },
  data() {
    return {
      is_loading: true,
      temp: [],
      full_data: [],
      filter_data: {
        account: this.$route.query.account,
        from_date: this.$route?.query?.from_date,
        to_date: this.$route?.query?.to_date,
      },
      pagination: {
        page: 1,
        items: 10,
        count: 0,
      },
      table_data: {
        fields: [
          {
            key: "no",
            label: "no",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "1rem" },
          },
          {
            key: "content",
            label: "content",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "url",
            label: "url",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "date",
            label: "date",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "created_at",
            label: "created at",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center",
          },
        ],
        items: [],
      },
      modal_data: null,
      cancel_token: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    paginationChanged(data) {
      this.pagination = data;
      // this.getData();
      this.updateTableData();
    },
    getData() {
      this.is_loading = true;
      if (this.cancel_token) {
        this.cancel_token.cancel("ERR_CANCELED");
      }
      this.cancel_token = axios.CancelToken.source();

      let params = {
        key: this.filter_data.account,
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "facebook?" + query;

      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_token.token })
        .then((res) => {
          this.cancel_token.value = null;
          this.full_data = (res?.data?.facebook_data[0].post || []).map((item) => ({
            ...item,
            _id: item.url,
            account: this.filter_data.account,
          }));;
          this.temp = (res?.data?.facebook_data[0].post || []).map((item) => ({
            ...item,
            _id: item.url,
            content: this.shortenText(item.content, 100),
          }));
          this.pagination.count = this.temp.length; 
          this.updateTableData();
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_token.value = null;
          } else {
            this.cancel_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_token.value) {
            this.is_loading = false;
          }
        });
    },
    updateTableData() {
      const start = (this.pagination.page - 1) * this.pagination.items;
      const end = start + this.pagination.items;
      this.table_data.items = this.temp.slice(start, end);
    },
    shortenText(text, length = 100) {
      if (text === null || text === undefined) {
        return text = "-";
      }
      if (text.length > length) {
        return text.substring(0, length) + "...";
      }
      return text;
    },
    goBack() {
      this.$router.back();
    },
    viewDetail(url) {
      let data = this.full_data.filter((el) => el.url == url);
      this.modal_data = data[0];
      this.$bvModal.show("modal-content-facebook");
    },
  },
};
</script>
